import { api } from './api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    activatePinForAccessAc: build.mutation<ActivatePinForAccessAcApiResponse, ActivatePinForAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/pin/${queryArg.pinId}/activate`,
      }),
    }),
    activatePinForUserAc: build.mutation<ActivatePinForUserAcApiResponse, ActivatePinForUserAcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin/${queryArg.pinId}/activate`,
      }),
    }),
    addGroupToApartmentsAc: build.mutation<AddGroupToApartmentsAcApiResponse, AddGroupToApartmentsAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/apartments`,
      }),
    }),
    assignAccessAc: build.mutation<AssignAccessAcApiResponse, AssignAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/accesses/${queryArg.accessId}`,
      }),
    }),
    assignDeviceAc: build.mutation<AssignDeviceAcApiResponse, AssignDeviceAcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/devices/${queryArg.deviceId}`,
      }),
    }),
    assignGroupToApartment1Ac: build.mutation<AssignGroupToApartment1AcApiResponse, AssignGroupToApartment1AcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/groups/${queryArg.groupId}`,
      }),
    }),
    assignGroupToApartmentAc: build.mutation<AssignGroupToApartmentAcApiResponse, AssignGroupToApartmentAcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/apartments/${queryArg.apartmentId}`,
      }),
    }),
    assignPinToGuestAc: build.mutation<AssignPinToGuestAcApiResponse, AssignPinToGuestAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.pinAssignValidityDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin-with-validity`,
      }),
    }),
    assignPinToUserWithoutLoginAc: build.mutation<
      AssignPinToUserWithoutLoginAcApiResponse,
      AssignPinToUserWithoutLoginAcApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.pinAssignDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin/assign`,
      }),
    }),
    assignUserAc: build.mutation<AssignUserAcApiResponse, AssignUserAcApiArg>({
      query: (queryArg) => ({
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/users/${queryArg.userId}`,
      }),
    }),
    checkBluetoothAccessExistsAc: build.mutation<
      CheckBluetoothAccessExistsAcApiResponse,
      CheckBluetoothAccessExistsAcApiArg
    >({
      query: (queryArg) => ({
        method: 'HEAD',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/bluetooth`,
      }),
    }),
    createAccessAc: build.mutation<CreateAccessAcApiResponse, CreateAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses`,
      }),
    }),
    createBluetoothAc: build.mutation<CreateBluetoothAcApiResponse, CreateBluetoothAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth`,
      }),
    }),
    createBluetoothAccessAc: build.mutation<CreateBluetoothAccessAcApiResponse, CreateBluetoothAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/bluetooth`,
      }),
    }),
    createDeviceServiceAc: build.mutation<CreateDeviceServiceAcApiResponse, CreateDeviceServiceAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.createDeviceServiceDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices`,
      }),
    }),
    createGroupAc: build.mutation<CreateGroupAcApiResponse, CreateGroupAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.createUpdateGroupDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups`,
      }),
    }),
    createGuestPinWithoutAccessAc: build.query<
      CreateGuestPinWithoutAccessAcApiResponse,
      CreateGuestPinWithoutAccessAcApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/available-guest-pin`,
      }),
    }),
    createLprForAccessAc: build.mutation<CreateLprForAccessAcApiResponse, CreateLprForAccessAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.createLprDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/lpr`,
      }),
    }),
    createPinForAccessAc: build.mutation<CreatePinForAccessAcApiResponse, CreatePinForAccessAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.customPinRequestDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/pin`,
      }),
    }),
    createPinForUserAc: build.mutation<CreatePinForUserAcApiResponse, CreatePinForUserAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.customPinRequestDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin`,
      }),
    }),
    createPinWithoutAccessAc: build.query<CreatePinWithoutAccessAcApiResponse, CreatePinWithoutAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/available-pin`,
      }),
    }),
    createRfidForAccessAc: build.mutation<CreateRfidForAccessAcApiResponse, CreateRfidForAccessAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.createRfidDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/rfid`,
      }),
    }),
    createRfidForUserAc: build.mutation<CreateRfidForUserAcApiResponse, CreateRfidForUserAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.createRfidDto,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/rfid`,
      }),
    }),
    deleteAccessAc: build.mutation<DeleteAccessAcApiResponse, DeleteAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}`,
      }),
    }),
    deleteAllLprsForAccessAc: build.mutation<DeleteAllLprsForAccessAcApiResponse, DeleteAllLprsForAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/lpr`,
      }),
    }),
    deleteBluetoothAc: build.mutation<DeleteBluetoothAcApiResponse, DeleteBluetoothAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth`,
      }),
    }),
    deleteBluetoothAccessAc: build.mutation<DeleteBluetoothAccessAcApiResponse, DeleteBluetoothAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/bluetooth`,
      }),
    }),
    deleteDeviceServiceAc: build.mutation<DeleteDeviceServiceAcApiResponse, DeleteDeviceServiceAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL`,
      }),
    }),
    deleteGroupAc: build.mutation<DeleteGroupAcApiResponse, DeleteGroupAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}`,
      }),
    }),
    deleteLprForAccessAndLprIdAc: build.mutation<
      DeleteLprForAccessAndLprIdAcApiResponse,
      DeleteLprForAccessAndLprIdAcApiArg
    >({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/lpr/${queryArg.id}`,
      }),
    }),
    deletePinForAccessAc: build.mutation<DeletePinForAccessAcApiResponse, DeletePinForAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/pin`,
      }),
    }),
    deletePinForUserAc: build.mutation<DeletePinForUserAcApiResponse, DeletePinForUserAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin`,
      }),
    }),
    deleteRfidForAccessByIdAc: build.mutation<DeleteRfidForAccessByIdAcApiResponse, DeleteRfidForAccessByIdAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/rfid/${queryArg.rfidId}`,
      }),
    }),
    deleteRfidForUserByIdAc: build.mutation<DeleteRfidForUserByIdAcApiResponse, DeleteRfidForUserByIdAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/rfid/${queryArg.rfidId}`,
      }),
    }),
    deleteRfidsForAccessAc: build.mutation<DeleteRfidsForAccessAcApiResponse, DeleteRfidsForAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/rfid`,
      }),
    }),
    deleteRfidsForUserAc: build.mutation<DeleteRfidsForUserAcApiResponse, DeleteRfidsForUserAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/rfid`,
      }),
    }),
    disableBluetoothAc: build.mutation<DisableBluetoothAcApiResponse, DisableBluetoothAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth/disable`,
      }),
    }),
    enableBluetoothAc: build.mutation<EnableBluetoothAcApiResponse, EnableBluetoothAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth/enable`,
      }),
    }),
    getAccessAc: build.query<GetAccessAcApiResponse, GetAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}`,
      }),
    }),
    getAccessCredentialsValidityAc: build.query<
      GetAccessCredentialsValidityAcApiResponse,
      GetAccessCredentialsValidityAcApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials`,
      }),
    }),
    getAccessesInGroupAc: build.query<GetAccessesInGroupAcApiResponse, GetAccessesInGroupAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/accesses`,
      }),
    }),
    getAccessInSiteByRfidCodeAc: build.query<GetAccessInSiteByRfidCodeAcApiResponse, GetAccessInSiteByRfidCodeAcApiArg>(
      {
        query: (queryArg) => ({
          url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/credentials/rfid/${queryArg.rfidCode}`,
        }),
      }
    ),
    getAllAccessesInSiteAc: build.query<GetAllAccessesInSiteAcApiResponse, GetAllAccessesInSiteAcApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses` }),
    }),
    getAllLprsForAccessAc: build.query<GetAllLprsForAccessAcApiResponse, GetAllLprsForAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/lpr`,
      }),
    }),
    getApartmentGroupsAc: build.query<GetApartmentGroupsAcApiResponse, GetApartmentGroupsAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/groups`,
      }),
    }),
    getApartmentsOnSiteAc: build.query<GetApartmentsOnSiteAcApiResponse, GetApartmentsOnSiteAcApiArg>({
      query: (queryArg) => ({
        params: { coreId: queryArg.coreId },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments`,
      }),
    }),
    getBluetoothAc: build.query<GetBluetoothAcApiResponse, GetBluetoothAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth`,
      }),
    }),
    getBluetoothAccessAc: build.query<GetBluetoothAccessAcApiResponse, GetBluetoothAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/bluetooth`,
      }),
    }),
    getBluetoothStatusAc: build.query<GetBluetoothStatusAcApiResponse, GetBluetoothStatusAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth/status`,
      }),
    }),
    getCredentialsAc: build.mutation<GetCredentialsAcApiResponse, GetCredentialsAcApiArg>({
      query: (queryArg) => ({ body: queryArg.body, method: 'POST', url: `/users/credentials` }),
    }),
    getCredentialsForCompanyAc: build.mutation<GetCredentialsForCompanyAcApiResponse, GetCredentialsForCompanyAcApiArg>(
      {
        query: (queryArg) => ({
          body: queryArg.body,
          method: 'POST',
          url: `/companies/${queryArg.companyId}/users/credentials`,
        }),
      }
    ),
    getCredentialsForSiteAc: build.mutation<GetCredentialsForSiteAcApiResponse, GetCredentialsForSiteAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/credentials`,
      }),
    }),
    getDeviceAccessesAc: build.query<GetDeviceAccessesAcApiResponse, GetDeviceAccessesAcApiArg>({
      query: (queryArg) => ({
        params: {
          credential: queryArg.credential,
          limit: queryArg.limit,
          offset: queryArg.offset,
          order: queryArg.order,
          pageable: queryArg.pageable,
          syncStatus: queryArg.syncStatus,
        },
        url: `/companies/${queryArg.companyId}/device-synchronization/device-accesses`,
      }),
    }),
    getDeviceServicesAc: build.query<GetDeviceServicesAcApiResponse, GetDeviceServicesAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL`,
      }),
    }),
    getDeviceServicesInSiteAc: build.query<GetDeviceServicesInSiteAcApiResponse, GetDeviceServicesInSiteAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL`,
      }),
    }),
    getDeviceServicesWithoutRoleAc: build.query<
      GetDeviceServicesWithoutRoleAcApiResponse,
      GetDeviceServicesWithoutRoleAcApiArg
    >({
      query: (queryArg) => ({ url: `/devices/${queryArg.deviceId}/services/ACCESS_CONTROL` }),
    }),
    getDevicesInGroupAc: build.query<GetDevicesInGroupAcApiResponse, GetDevicesInGroupAcApiArg>({
      query: (queryArg) => ({
        params: { limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order, pageable: queryArg.pageable },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/devices`,
      }),
    }),
    getDevicesInSiteWithBleSupportedAc: build.query<
      GetDevicesInSiteWithBleSupportedAcApiResponse,
      GetDevicesInSiteWithBleSupportedAcApiArg
    >({
      query: (queryArg) => ({
        params: { bleSupported: queryArg.bleSupported },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices`,
      }),
    }),
    getDeviceUnlockOverApiAc: build.query<GetDeviceUnlockOverApiAcApiResponse, GetDeviceUnlockOverApiAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL/unlockOverApi`,
      }),
    }),
    getGroupAc: build.query<GetGroupAcApiResponse, GetGroupAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}`,
      }),
    }),
    getGroupsInSiteByAccessAc: build.query<GetGroupsInSiteByAccessAcApiResponse, GetGroupsInSiteByAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/groups`,
      }),
    }),
    getGroupsInSiteByDeviceAc: build.query<GetGroupsInSiteByDeviceAcApiResponse, GetGroupsInSiteByDeviceAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/groups`,
      }),
    }),
    getGroupsInSiteByUserAc: build.query<GetGroupsInSiteByUserAcApiResponse, GetGroupsInSiteByUserAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/groups`,
      }),
    }),
    getGroupsOfUsersInSiteAc: build.mutation<GetGroupsOfUsersInSiteAcApiResponse, GetGroupsOfUsersInSiteAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users-by-groups`,
      }),
    }),
    getLprByAccessAndLprIdAc: build.query<GetLprByAccessAndLprIdAcApiResponse, GetLprByAccessAndLprIdAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/lpr/${queryArg.id}`,
      }),
    }),
    getOfflinePairingAc: build.query<GetOfflinePairingAcApiResponse, GetOfflinePairingAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/bluetooth/offline-pairing-detection`,
      }),
    }),
    getPinByIdForAccessAc: build.query<GetPinByIdForAccessAcApiResponse, GetPinByIdForAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/pin/${queryArg.pinId}`,
      }),
    }),
    getPinByIdForUserAc: build.query<GetPinByIdForUserAcApiResponse, GetPinByIdForUserAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin/${queryArg.pinId}`,
      }),
    }),
    getPinForAccessAc: build.query<GetPinForAccessAcApiResponse, GetPinForAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/pin`,
      }),
    }),
    getPinForUserAc: build.query<GetPinForUserAcApiResponse, GetPinForUserAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/pin`,
      }),
    }),
    getRfidForAccessByIdAc: build.query<GetRfidForAccessByIdAcApiResponse, GetRfidForAccessByIdAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/rfid/${queryArg.rfidId}`,
      }),
    }),
    getRfidForUserByIdAc: build.query<GetRfidForUserByIdAcApiResponse, GetRfidForUserByIdAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/rfid/${queryArg.rfidId}`,
      }),
    }),
    getRfidsForAccessAc: build.query<GetRfidsForAccessAcApiResponse, GetRfidsForAccessAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/rfid`,
      }),
    }),
    getRfidsForUserAc: build.query<GetRfidsForUserAcApiResponse, GetRfidsForUserAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/rfid`,
      }),
    }),
    getServicesAc: build.mutation<GetServicesAcApiResponse, GetServicesAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/devices/services`,
      }),
    }),
    getServicesInSiteAc: build.query<GetServicesInSiteAcApiResponse, GetServicesInSiteAcApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/services` }),
    }),
    getServicesInSiteByDeviceIdsAc: build.mutation<
      GetServicesInSiteByDeviceIdsAcApiResponse,
      GetServicesInSiteByDeviceIdsAcApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/services`,
      }),
    }),
    getServicesWithoutRoleAc: build.mutation<GetServicesWithoutRoleAcApiResponse, GetServicesWithoutRoleAcApiArg>({
      query: (queryArg) => ({ body: queryArg.body, method: 'POST', url: `/devices/services` }),
    }),
    getSiteCredentialsSettingsAc: build.query<
      GetSiteCredentialsSettingsAcApiResponse,
      GetSiteCredentialsSettingsAcApiArg
    >({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials` }),
    }),
    getSiteGuestPinSettingsAc: build.query<GetSiteGuestPinSettingsAcApiResponse, GetSiteGuestPinSettingsAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/guest-pin-settings`,
      }),
    }),
    getUnlockOverApiDevicesForUserAc: build.query<
      GetUnlockOverApiDevicesForUserAcApiResponse,
      GetUnlockOverApiDevicesForUserAcApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/unlock-over-api-devices`,
      }),
    }),
    getUserApartmentsAc: build.query<GetUserApartmentsAcApiResponse, GetUserApartmentsAcApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/apartments`,
      }),
    }),
    getUserCredentialsValidityAc: build.query<
      GetUserCredentialsValidityAcApiResponse,
      GetUserCredentialsValidityAcApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials`,
      }),
    }),
    getUsersInGroupAc: build.query<GetUsersInGroupAcApiResponse, GetUsersInGroupAcApiArg>({
      query: (queryArg) => ({
        params: { limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order, pageable: queryArg.pageable },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/users`,
      }),
    }),
    listAllApartmentsAc: build.query<ListAllApartmentsAcApiResponse, ListAllApartmentsAcApiArg>({
      query: (queryArg) => ({
        params: { limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order, pageable: queryArg.pageable },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/apartments`,
      }),
    }),
    listAllGroups1Ac: build.query<ListAllGroups1AcApiResponse, ListAllGroups1AcApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups-all` }),
    }),
    listAllGroupsAc: build.query<ListAllGroupsAcApiResponse, ListAllGroupsAcApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups` }),
    }),
    listAllGroupsPagedAc: build.query<ListAllGroupsPagedAcApiResponse, ListAllGroupsPagedAcApiArg>({
      query: (queryArg) => ({
        params: { limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order, pageable: queryArg.pageable },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups-paged`,
      }),
    }),
    putAccessesIntoGroupAc: build.mutation<PutAccessesIntoGroupAcApiResponse, PutAccessesIntoGroupAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/accesses`,
      }),
    }),
    putAccessIntoGroupsAc: build.mutation<PutAccessIntoGroupsAcApiResponse, PutAccessIntoGroupsAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/groups`,
      }),
    }),
    putDeviceIntoGroupsAc: build.mutation<PutDeviceIntoGroupsAcApiResponse, PutDeviceIntoGroupsAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/groups`,
      }),
    }),
    putDevicesIntoGroupAc: build.mutation<PutDevicesIntoGroupAcApiResponse, PutDevicesIntoGroupAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/devices`,
      }),
    }),
    putUserIntoGroupsAc: build.mutation<PutUserIntoGroupsAcApiResponse, PutUserIntoGroupsAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/groups`,
      }),
    }),
    putUsersIntoGroupAc: build.mutation<PutUsersIntoGroupAcApiResponse, PutUsersIntoGroupAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/users`,
      }),
    }),
    recreateBluetoothAc: build.mutation<RecreateBluetoothAcApiResponse, RecreateBluetoothAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials/bluetooth/authid`,
      }),
    }),
    recreateBluetoothAccessAc: build.mutation<RecreateBluetoothAccessAcApiResponse, RecreateBluetoothAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials/bluetooth/authid`,
      }),
    }),
    removeAccessAc: build.mutation<RemoveAccessAcApiResponse, RemoveAccessAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/accesses/${queryArg.accessId}`,
      }),
    }),
    removeDeviceAc: build.mutation<RemoveDeviceAcApiResponse, RemoveDeviceAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/devices/${queryArg.deviceId}`,
      }),
    }),
    removeGroupFromApartment1Ac: build.mutation<
      RemoveGroupFromApartment1AcApiResponse,
      RemoveGroupFromApartment1AcApiArg
    >({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/groups/${queryArg.groupId}`,
      }),
    }),
    removeGroupFromApartmentAc: build.mutation<RemoveGroupFromApartmentAcApiResponse, RemoveGroupFromApartmentAcApiArg>(
      {
        query: (queryArg) => ({
          method: 'DELETE',
          url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/apartments/${queryArg.apartmentId}`,
        }),
      }
    ),
    removeUserAc: build.mutation<RemoveUserAcApiResponse, RemoveUserAcApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/users/${queryArg.userId}`,
      }),
    }),
    setAccessLogActiveAc: build.mutation<SetAccessLogActiveAcApiResponse, SetAccessLogActiveAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.accessLogActiveDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL/accesslog`,
      }),
    }),
    setAcmActiveAc: build.mutation<SetAcmActiveAcApiResponse, SetAcmActiveAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.serviceActiveDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL`,
      }),
    }),
    setDeviceUnlockOverApiServiceAc: build.mutation<
      SetDeviceUnlockOverApiServiceAcApiResponse,
      SetDeviceUnlockOverApiServiceAcApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.unlockOverApiDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL/unlockOverApi`,
      }),
    }),
    setGroupsToApartmentAc: build.mutation<SetGroupsToApartmentAcApiResponse, SetGroupsToApartmentAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/groups`,
      }),
    }),
    triggerUnlockOverApiAc: build.mutation<TriggerUnlockOverApiAcApiResponse, TriggerUnlockOverApiAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.unlockOverApiRequest,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/unlock-over-api`,
      }),
    }),
    updateAccessCredentialsValidityAc: build.mutation<
      UpdateAccessCredentialsValidityAcApiResponse,
      UpdateAccessCredentialsValidityAcApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.credentialsValidityDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/accesses/${queryArg.accessId}/credentials`,
      }),
    }),
    updateGroupAc: build.mutation<UpdateGroupAcApiResponse, UpdateGroupAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.createUpdateGroupDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}`,
      }),
    }),
    updateSiteBluetoothAc: build.mutation<UpdateSiteBluetoothAcApiResponse, UpdateSiteBluetoothAcApiArg>({
      query: (queryArg) => ({
        body: queryArg.siteBluetoothEnabledDto,
        method: 'PATCH',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials`,
      }),
    }),
    updateSiteCustomLocationAc: build.mutation<UpdateSiteCustomLocationAcApiResponse, UpdateSiteCustomLocationAcApiArg>(
      {
        query: (queryArg) => ({
          body: queryArg.siteCustomLocationDto,
          method: 'PATCH',
          url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/bluetooth`,
        }),
      }
    ),
    updateSiteGuestPinSettingsAc: build.mutation<
      UpdateSiteGuestPinSettingsAcApiResponse,
      UpdateSiteGuestPinSettingsAcApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.guestPinSettingsDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials/guest-pin-settings`,
      }),
    }),
    updateUserCredentialsValidityAc: build.mutation<
      UpdateUserCredentialsValidityAcApiResponse,
      UpdateUserCredentialsValidityAcApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.credentialsValidityDto,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}/credentials`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as accessControlApi };
export type GetGroupsInSiteByUserAcApiResponse = /** status 200 User groups */ GroupDto[];
export type GetGroupsInSiteByUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type PutUserIntoGroupsAcApiResponse = /** status 204 User assigned */ undefined;
export type PutUserIntoGroupsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  body: string[];
};
export type ActivatePinForUserAcApiResponse = /** status 204 PIN activated */ undefined;
export type ActivatePinForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  /** uuid of the pin */
  pinId: string;
};
export type AssignPinToUserWithoutLoginAcApiResponse = /** status 200 PIN assigned */ PinAssignedDto;
export type AssignPinToUserWithoutLoginAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  pinAssignDto: PinAssignDto;
};
export type AssignPinToGuestAcApiResponse = /** status 200 PIN assigned */ PinAssignedValidityDto;
export type AssignPinToGuestAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  pinAssignValidityDto: PinAssignValidityDto;
};
export type GetUserCredentialsValidityAcApiResponse =
  /** status 200 User Credentials validity in site */ CredentialsValidityResponseDto;
export type GetUserCredentialsValidityAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type UpdateUserCredentialsValidityAcApiResponse =
  /** status 204 Access Credentials validity in site updated */ undefined;
export type UpdateUserCredentialsValidityAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  credentialsValidityDto: CredentialsValidityDto;
};
export type AssignUserAcApiResponse = /** status 204 User assigned */ undefined;
export type AssignUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** uuid of the user */
  userId: string;
};
export type RemoveUserAcApiResponse = /** status 204 User was removed from Group */ undefined;
export type RemoveUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** uuid of the user */
  userId: string;
};
export type GetUsersInGroupAcApiResponse = /** status 200 All Users assigned */ UserPageResponseDto;
export type GetUsersInGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** Zero-based offset (0..N), where to start a page */
  offset?: number;
  /** The size of the page to be returned */
  limit?: number;
  /** Sorting criteria in the format: (,-)property. Default sort order is ascending. */
  order?: string;
  pageable: Pageable;
};
export type PutUsersIntoGroupAcApiResponse = /** status 204 Users set */ undefined;
export type PutUsersIntoGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  body: string[];
};
export type AssignDeviceAcApiResponse = /** status 204 Device assigned */ undefined;
export type AssignDeviceAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type RemoveDeviceAcApiResponse = /** status 204 Device was removed from Group */ undefined;
export type RemoveDeviceAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type GetDevicesInGroupAcApiResponse = /** status 200 All Devices assigned */ DevicePageResponseDto;
export type GetDevicesInGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** Zero-based offset (0..N), where to start a page */
  offset?: number;
  /** The size of the page to be returned */
  limit?: number;
  /** Sorting criteria in the format: (,-)property. Default sort order is ascending. */
  order?: string;
  pageable: Pageable;
};
export type PutDevicesIntoGroupAcApiResponse = /** status 204 Devices set */ undefined;
export type PutDevicesIntoGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  body: string[];
};
export type AssignGroupToApartmentAcApiResponse = /** status 204 Group was assigned to an apartment */ undefined;
export type AssignGroupToApartmentAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** String representation of numeric apartmentId of the Apartment to perform action with. */
  apartmentId: string;
};
export type RemoveGroupFromApartmentAcApiResponse = /** status 204 Group was removed from apartment */ undefined;
export type RemoveGroupFromApartmentAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** String representation of numeric apartmentId of the Apartment to perform action with. */
  apartmentId: string;
};
export type ListAllApartmentsAcApiResponse = /** status 200 OK */ ApartmentPageResponseDto;
export type ListAllApartmentsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** List of field names for sorting returned list of apartments. For descending order use the prefix '-' before given field name."  */
  order?: string[];
  /** Zero-based offset (0..N), where to start a page */
  offset?: number;
  /** The size of the page to be returned */
  limit?: number;
  pageable: Pageable;
};
export type AddGroupToApartmentsAcApiResponse = /** status 204 Group was added to apartments */ undefined;
export type AddGroupToApartmentsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  body: string[];
};
export type AssignAccessAcApiResponse = /** status 204 Access assigned */ undefined;
export type AssignAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** uuid of the access */
  accessId: string;
};
export type RemoveAccessAcApiResponse = /** status 204 Access was removed from Group */ undefined;
export type RemoveAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  /** uuid of the access */
  accessId: string;
};
export type GetAccessesInGroupAcApiResponse = /** status 200 All Accesses assigned */ AccessDto[];
export type GetAccessesInGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
};
export type PutAccessesIntoGroupAcApiResponse = /** status 204 Accesses set */ undefined;
export type PutAccessesIntoGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  body: string[];
};
export type GetGroupAcApiResponse = /** status 200 Group */ GroupUsersDevicesDto;
export type GetGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
};
export type UpdateGroupAcApiResponse = /** status 204 Group updated */ undefined;
export type UpdateGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
  createUpdateGroupDto: CreateUpdateGroupDto;
};
export type DeleteGroupAcApiResponse = /** status 204 Group was deleted */ undefined;
export type DeleteGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the group */
  groupId: string;
};
export type GetDeviceUnlockOverApiAcApiResponse =
  /** status 200 Device Unlock over API service status */ UnlockOverApiResponseDto;
export type GetDeviceUnlockOverApiAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type SetDeviceUnlockOverApiServiceAcApiResponse =
  /** status 204 Device Unlock over API service was updated */ undefined;
export type SetDeviceUnlockOverApiServiceAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
  unlockOverApiDto: UnlockOverApiDto;
};
export type SetAccessLogActiveAcApiResponse = /** status 200 Device service was updated */ ServiceDto;
export type SetAccessLogActiveAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
  accessLogActiveDto: AccessLogActiveDto;
};
export type GetDeviceServicesInSiteAcApiResponse = /** status 200 Device detail */ ServiceDto;
export type GetDeviceServicesInSiteAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type SetAcmActiveAcApiResponse = /** status 200 Device service was updated */ ServiceDto;
export type SetAcmActiveAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
  serviceActiveDto: ServiceActiveDto;
};
export type DeleteDeviceServiceAcApiResponse = /** status 204 Device service was deleted */ undefined;
export type DeleteDeviceServiceAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type GetGroupsInSiteByDeviceAcApiResponse = /** status 200 Device groups */ GroupDto[];
export type GetGroupsInSiteByDeviceAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type PutDeviceIntoGroupsAcApiResponse = /** status 204 Device set */ undefined;
export type PutDeviceIntoGroupsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
  body: string[];
};
export type GetSiteGuestPinSettingsAcApiResponse = /** status 200 guest pin settings */ GuestPinSettingsDto;
export type GetSiteGuestPinSettingsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type UpdateSiteGuestPinSettingsAcApiResponse = /** status 200 guest pin settings */ GuestPinSettingsDto;
export type UpdateSiteGuestPinSettingsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  guestPinSettingsDto: GuestPinSettingsDto;
};
export type AssignGroupToApartment1AcApiResponse = /** status 204 Group was assigned to an apartment */ undefined;
export type AssignGroupToApartment1AcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric apartmentId of the Apartment to perform action with. */
  apartmentId: string;
  /** uuid of the group */
  groupId: string;
};
export type RemoveGroupFromApartment1AcApiResponse = /** status 204 Group was removed from apartment */ undefined;
export type RemoveGroupFromApartment1AcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric apartmentId of the Apartment to perform action with. */
  apartmentId: string;
  /** uuid of the group */
  groupId: string;
};
export type GetApartmentGroupsAcApiResponse = /** status 200 Apartment group */ GroupDto[];
export type GetApartmentGroupsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric apartmentId of the Apartment to perform action with. */
  apartmentId: string;
};
export type SetGroupsToApartmentAcApiResponse = /** status 204 Groups were set to an apartment */ undefined;
export type SetGroupsToApartmentAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** String representation of numeric apartmentId of the Apartment to perform action with. */
  apartmentId: string;
  body: string[];
};
export type GetGroupsInSiteByAccessAcApiResponse = /** status 200 Access groups */ GroupDto[];
export type GetGroupsInSiteByAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type PutAccessIntoGroupsAcApiResponse = /** status 204 Access set */ undefined;
export type PutAccessIntoGroupsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  body: string[];
};
export type ActivatePinForAccessAcApiResponse = /** status 204 PIN activated */ undefined;
export type ActivatePinForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  /** uuid of the pin */
  pinId: string;
};
export type GetAccessCredentialsValidityAcApiResponse =
  /** status 200 Access Credentials validity */ CredentialsValidityResponseDto;
export type GetAccessCredentialsValidityAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type UpdateAccessCredentialsValidityAcApiResponse =
  /** status 204 Access Credentials validity updated */ undefined;
export type UpdateAccessCredentialsValidityAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  credentialsValidityDto: CredentialsValidityDto;
};
export type GetCredentialsAcApiResponse = /** status 200 User credentials */ UserCredentialsDto[];
export type GetCredentialsAcApiArg = {
  body: string[];
};
export type GetServicesWithoutRoleAcApiResponse =
  /** status 200 List of all services for queried devices */ DeviceServiceDto[];
export type GetServicesWithoutRoleAcApiArg = {
  body: string[];
};
export type GetCredentialsForCompanyAcApiResponse = /** status 200 User credentials */ UserCredentialsDto[];
export type GetCredentialsForCompanyAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  body: string[];
};
export type TriggerUnlockOverApiAcApiResponse =
  /** status 204 The device successfully unlocked over API for the user */ undefined;
export type TriggerUnlockOverApiAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  unlockOverApiRequest: UnlockOverApiRequest;
};
export type GetRfidsForUserAcApiResponse = /** status 200 RFID */ RfidDto[];
export type GetRfidsForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type CreateRfidForUserAcApiResponse = /** status 200 created RFID */ RfidDto;
export type CreateRfidForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  createRfidDto: CreateRfidDto;
};
export type DeleteRfidsForUserAcApiResponse = /** status 204 RFIDs were deleted */ undefined;
export type DeleteRfidsForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type GetPinForUserAcApiResponse = /** status 200 Active PIN */ PinDto;
export type GetPinForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type CreatePinForUserAcApiResponse = /** status 200 Generated PIN */ PinDto;
export type CreatePinForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  customPinRequestDto: CustomPinRequestDto;
};
export type DeletePinForUserAcApiResponse = /** status 204 PIN was deleted */ undefined;
export type DeletePinForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type EnableBluetoothAcApiResponse = /** status 204 Bluetooth enabled */ undefined;
export type EnableBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type DisableBluetoothAcApiResponse = /** status 204 Bluetooth disabled */ undefined;
export type DisableBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type RecreateBluetoothAcApiResponse = /** status 200 Bluetooth recreated */ BluetoothDto;
export type RecreateBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type GetBluetoothAcApiResponse = /** status 200 Bluetooth User Credentials */ BluetoothDto;
export type GetBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type CreateBluetoothAcApiResponse = /** status 204 Bluetooth created */ undefined;
export type CreateBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type DeleteBluetoothAcApiResponse = /** status 204 Bluetooth was deleted */ undefined;
export type DeleteBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type GetCredentialsForSiteAcApiResponse =
  /** status 200 User credentials */ UserCredentialsWithApartmentAccessDto[];
export type GetCredentialsForSiteAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  body: string[];
};
export type GetGroupsOfUsersInSiteAcApiResponse = /** status 200 User groups */ GroupsByUserUuidsDto;
export type GetGroupsOfUsersInSiteAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  body: string[];
};
export type ListAllGroupsAcApiResponse = /** status 200 OK */ CustomPageDtoGroupUsersDevicesDto | GroupDto[];
export type ListAllGroupsAcApiArg = {
  siteId: string;
  companyId: string;
};
export type CreateGroupAcApiResponse = /** status 200 Group created */ GroupDto;
export type CreateGroupAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  createUpdateGroupDto: CreateUpdateGroupDto;
};
export type GetServicesInSiteAcApiResponse =
  /** status 200 List of all services for devices in site */ DeviceServiceDto[];
export type GetServicesInSiteAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type GetServicesInSiteByDeviceIdsAcApiResponse =
  /** status 200 List of all services for queried devices */ DeviceServiceDto[];
export type GetServicesInSiteByDeviceIdsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  body: string[];
};
export type GetDevicesInSiteWithBleSupportedAcApiResponse =
  /** status 200 Devices with bleSupported property */ DeviceWithBleSupportedDto[];
export type GetDevicesInSiteWithBleSupportedAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  bleSupported?: boolean;
};
export type CreateDeviceServiceAcApiResponse = /** status 201 Device service was created */ CreateDeviceServiceDto;
export type CreateDeviceServiceAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  createDeviceServiceDto: CreateDeviceServiceDto;
};
export type GetRfidsForAccessAcApiResponse = /** status 200 RFID */ RfidDto[];
export type GetRfidsForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type CreateRfidForAccessAcApiResponse = /** status 200 created RFID */ RfidDto;
export type CreateRfidForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  createRfidDto: CreateRfidDto;
};
export type DeleteRfidsForAccessAcApiResponse = /** status 204 RFIDs were deleted */ undefined;
export type DeleteRfidsForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type GetPinForAccessAcApiResponse = /** status 200 Active PIN */ PinDto;
export type GetPinForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type CreatePinForAccessAcApiResponse = /** status 200 Generated PIN */ PinDto;
export type CreatePinForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  customPinRequestDto: CustomPinRequestDto;
};
export type DeletePinForAccessAcApiResponse = /** status 204 PIN was deleted */ undefined;
export type DeletePinForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type GetAllLprsForAccessAcApiResponse = /** status 200 All LPR Credentials for Access */ LprDto[];
export type GetAllLprsForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type CreateLprForAccessAcApiResponse = /** status 200 LPR Credentials for Access created */ LprDto;
export type CreateLprForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  createLprDto: CreateLprDto;
};
export type DeleteAllLprsForAccessAcApiResponse = /** status 204 All LPR credentials for Access deleted */ undefined;
export type DeleteAllLprsForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type RecreateBluetoothAccessAcApiResponse = /** status 204 Bluetooth recreated */ undefined;
export type RecreateBluetoothAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type GetBluetoothAccessAcApiResponse = /** status 200 Bluetooth Access Credentials */ BluetoothDto;
export type GetBluetoothAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type CreateBluetoothAccessAcApiResponse = /** status 204 Bluetooth created */ undefined;
export type CreateBluetoothAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type DeleteBluetoothAccessAcApiResponse = /** status 204 Bluetooth was deleted */ undefined;
export type DeleteBluetoothAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type GetAllAccessesInSiteAcApiResponse = /** status 200 All Accesses in site */ AccessDto[];
export type GetAllAccessesInSiteAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type CreateAccessAcApiResponse = /** status 200 created Access */ AccessDto;
export type CreateAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type GetServicesAcApiResponse = /** status 200 List of all services for queried devices */ DeviceServiceDto[];
export type GetServicesAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  body: string[];
};
export type CheckBluetoothAccessExistsAcApiResponse = unknown;
export type CheckBluetoothAccessExistsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type UpdateSiteCustomLocationAcApiResponse = /** status 204 Site customLocationId has been updated */ undefined;
export type UpdateSiteCustomLocationAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  siteCustomLocationDto: SiteCustomLocationDto;
};
export type GetSiteCredentialsSettingsAcApiResponse = /** status 200 settings for site */ SiteCredentialsSettingsDto;
export type GetSiteCredentialsSettingsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type UpdateSiteBluetoothAcApiResponse = /** status 204 Bluetooth setting updated */ undefined;
export type UpdateSiteBluetoothAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  siteBluetoothEnabledDto: SiteBluetoothEnabledDto;
};
export type GetDeviceServicesWithoutRoleAcApiResponse = /** status 200 Device detail */ ServiceDto[];
export type GetDeviceServicesWithoutRoleAcApiArg = {
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type GetUnlockOverApiDevicesForUserAcApiResponse =
  /** status 200 list of devices that allow unlocking via the API service and whether this service is enabled for the user */ DeviceUnlockOverApiForUserDto[];
export type GetUnlockOverApiDevicesForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type GetRfidForUserByIdAcApiResponse = /** status 200 RFID */ RfidDto;
export type GetRfidForUserByIdAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  /** uuid of the rfid */
  rfidId: string;
};
export type DeleteRfidForUserByIdAcApiResponse = /** status 204 RFID was deleted */ undefined;
export type DeleteRfidForUserByIdAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  /** uuid of the rfid */
  rfidId: string;
};
export type GetPinByIdForUserAcApiResponse = /** status 200 PIN */ PinDto;
export type GetPinByIdForUserAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
  /** uuid of the pin */
  pinId: string;
};
export type GetBluetoothStatusAcApiResponse =
  /** status 200 Status of Bluetooth for a User with enabled status and hash of actual authId */ BluetoothUserSiteStatusDto;
export type GetBluetoothStatusAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type GetUserApartmentsAcApiResponse = /** status 200 User apartments in site */ UserApartmentDto[];
export type GetUserApartmentsAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the user */
  userId: string;
};
export type ListAllGroupsPagedAcApiResponse = /** status 200 OK */ GroupPageResponseDto;
export type ListAllGroupsPagedAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** Zero-based offset (0..N), where to start a page */
  offset?: number;
  /** The size of the page to be returned */
  limit?: number;
  /** Sorting criteria in the format: (,-)property. Default sort order is ascending. */
  order?: string;
  pageable: Pageable;
};
export type ListAllGroups1AcApiResponse = /** status 200 OK */ GroupDto[];
export type ListAllGroups1AcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type GetOfflinePairingAcApiResponse =
  /** status 200 Whether offline pairing and ACOM settings specially is used. Location Ids of devices acquired from DMS are provided. */ OfflinePairingDto;
export type GetOfflinePairingAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type CreatePinWithoutAccessAcApiResponse = /** status 200 created Pin */ PinValueDto;
export type CreatePinWithoutAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type CreateGuestPinWithoutAccessAcApiResponse = /** status 200 created Pin */ PinValueDto;
export type CreateGuestPinWithoutAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
};
export type GetApartmentsOnSiteAcApiResponse =
  /** status 200 For list of apartments is getting number of devices assigned to particular apartment and number of groups particular apartment is assigned to */ SiteApartmentDto[];
export type GetApartmentsOnSiteAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  coreId: string[];
};
export type GetRfidForAccessByIdAcApiResponse = /** status 200 RFID */ RfidDto;
export type GetRfidForAccessByIdAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  /** uuid of the rfid */
  rfidId: string;
};
export type DeleteRfidForAccessByIdAcApiResponse = /** status 204 RFID was deleted */ undefined;
export type DeleteRfidForAccessByIdAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  /** uuid of the rfid */
  rfidId: string;
};
export type GetPinByIdForAccessAcApiResponse = /** status 200 PIN */ PinDto;
export type GetPinByIdForAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  /** uuid of the pin */
  pinId: string;
};
export type GetLprByAccessAndLprIdAcApiResponse = /** status 200 Credentials for LPR and Access */ LprDto;
export type GetLprByAccessAndLprIdAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  /** uuid of the lpr */
  id: string;
};
export type DeleteLprForAccessAndLprIdAcApiResponse =
  /** status 204 Credentials for LPR and Access deleted */ undefined;
export type DeleteLprForAccessAndLprIdAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
  /** uuid of the lpr */
  id: string;
};
export type GetAccessAcApiResponse = /** status 200 Access */ AccessDto;
export type GetAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type DeleteAccessAcApiResponse = /** status 204 Access was deleted */ undefined;
export type DeleteAccessAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  /** uuid of the access */
  accessId: string;
};
export type GetAccessInSiteByRfidCodeAcApiResponse = /** status 200 Access ID and User ID */ AccessUserDto;
export type GetAccessInSiteByRfidCodeAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric siteId of the Site to perform action with. */
  siteId: string;
  rfidCode: string;
};
export type GetDeviceServicesAcApiResponse = /** status 200 Device detail */ ServiceDto[];
export type GetDeviceServicesAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** String representation of numeric id of a Device to perform action with. */
  deviceId: string;
};
export type GetDeviceAccessesAcApiResponse = /** status 200 OK */ DeviceAccessPageResponseDto;
export type GetDeviceAccessesAcApiArg = {
  /** String representation of numeric companyId of the Company to perform action with. */
  companyId: string;
  /** List of field names for sorting returned results. For descending order use the prefix '-' before given field name. */
  order?: string[];
  /** List of credential types to find. */
  credential?: string[];
  /** List of sync statuses to find. */
  syncStatus?: string[];
  /** Zero-based offset (0..N), where to start a page */
  offset?: number;
  /** The size of the page to be returned */
  limit?: number;
  pageable: Pageable;
};
export type GroupDto = {
  id?: string;
  name?: string;
  description?: string;
  siteId?: string;
};
export type ServerErrorResponse = {
  message?: string;
  detail?: object;
  uuid?: string;
};
export type PinAssignedDto = {
  pinId?: string;
  active?: boolean;
};
export type PinAssignDto = {
  active?: boolean;
  pin: string;
};
export type PinAssignedValidityDto = {
  pinId?: string;
  validTo?: string;
  validFrom?: string;
  apartmentAccess?: boolean;
};
export type PinAssignValidityDto = {
  pin: string;
  validFrom?: string;
  validTo?: string;
  site?: string;
  emails?: string[];
  apartmentAccess?: boolean;
};
export type CredentialsValidityResponseDto = {
  validFrom?: string;
  validTo?: string;
  apartmentAccess?: boolean;
};
export type CredentialsValidityDto = {
  validFrom?: string;
  validTo?: string;
};
export type CredentialsDto = 'PIN' | 'RFID' | 'BT' | 'LPR';
export type GroupUserApartmentDto = {
  id?: string;
  coreId?: string;
  name?: string;
  number?: string;
  siteId?: string;
};
export type GroupUserDto = {
  credentials?: CredentialsDto[];
  groups?: GroupDto[];
  apartments?: GroupUserApartmentDto[];
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
};
export type UserPageResponseDto = {
  results?: GroupUserDto[];
  resultsTotal?: number;
};
export type Pageable = {
  page?: number;
  size?: number;
  sort?: string[];
};
export type DeviceGroupsDto = {
  accessControl?: boolean;
  accessLog?: boolean;
  groups?: GroupDto[];
  deviceId?: string;
  deviceName?: string;
  deviceType?: string;
};
export type DevicePageResponseDto = {
  results?: DeviceGroupsDto[];
  resultsTotal?: number;
};
export type ApartmentDto = {
  id?: string;
  coreId?: string;
  name?: string;
  number?: string;
  siteId?: string;
  floor?: string;
  userCount?: number;
  groups?: GroupDto[];
};
export type ApartmentPageResponseDto = {
  results?: ApartmentDto[];
  resultsTotal?: number;
};
export type AccessDto = {
  id?: string;
};
export type DeviceAcServiceDto = {
  accessControl?: boolean;
  deviceId?: string;
  deviceName?: string;
  deviceType?: string;
};
export type GroupUsersDevicesDto = {
  id?: string;
  name?: string;
  description?: string;
  siteId?: string;
  users?: number;
  apartments?: number;
  devices?: DeviceAcServiceDto[];
};
export type CreateUpdateGroupDto = {
  name: string;
  description?: string;
};
export type UnlockOverApiResponseDto = {
  active?: boolean;
};
export type UnlockOverApiDto = {
  active: boolean;
};
export type ServiceState = 'CREATING';
export type ServiceDto = {
  active?: boolean;
  type?: string;
  dateCreated?: string;
  lastUpdated?: string;
  status?: ServiceState;
  accessLog?: boolean;
  additionalProperties?: {
    [key: string]: object;
  };
};
export type AccessLogActiveDto = {
  active: boolean;
};
export type ServiceActiveDto = {
  active: boolean;
};
export type GuestPinSettingsDto = {
  guestPinLength?: number;
  guestShowQr?: boolean;
};
export type UserCredentialsDto = {
  userId: string;
  credentials: CredentialsDto[];
  validFrom?: string;
  validTo?: string;
};
export type DeviceServiceDto = {
  deviceId?: string;
  services?: ServiceDto[];
};
export type ServerErrorResponseWithErrorCode = {
  message?: string;
  detail?: object;
  uuid?: string;
  errorCode?: string;
};
export type UnlockOverApiRequest = {
  deviceId: string;
  _switch?: number;
  switch: number;
};
export type RfidDto = {
  id?: string;
  rfidCode?: string;
};
export type CreateRfidDto = {
  rfidCode: string;
};
export type PinDto = {
  id?: string;
  pin?: string;
  active?: boolean;
  link?: string;
};
export type CustomPinRequestDto = {
  pin: string;
  active?: boolean;
};
export type BluetoothDto = {
  id?: string;
  authId?: string;
  authIdHash?: string;
  locationId?: string;
  publicKey?: string;
  keyId?: string;
};
export type UserCredentialsWithApartmentAccessDto = {
  userId: string;
  credentials: CredentialsDto[];
  validFrom?: string;
  validTo?: string;
  apartmentAccess?: boolean;
};
export type GroupsByUserUuidsDto = {
  result?: {
    [key: string]: GroupDto[];
  };
};
export type CustomPageDtoGroupUsersDevicesDto = {
  results?: GroupUsersDevicesDto[];
  resultsTotal?: number;
};
export type DeviceWithBleSupportedDto = {
  id: string;
  name?: string;
  type: string;
  sn: string;
  bleSupported: boolean;
};
export type CreateDeviceServiceDto = {
  id?: string;
  serialNumber?: string;
  deviceType?: string;
  services?: ServiceDto[];
  additionalProperties?: {
    [key: string]: object;
  };
};
export type LprDto = {
  id?: string;
  licensePlate?: string;
};
export type CreateLprDto = {
  licensePlate?: string;
};
export type SiteCustomLocationDto = {
  locationId: string;
};
export type BluetoothManagementStateEnum =
  | 'UNDECIDED'
  | 'MANAGED'
  | 'NOT_MANAGED'
  | 'MANAGED_INCLUDING_OFFLINE'
  | 'RECONFIGURATION_REQUIRED';
export type SiteCredentialsSettingsDto = {
  bluetoothManagementState?: BluetoothManagementStateEnum;
  bluetoothEnabled: boolean;
  locationId?: string;
};
export type SiteBluetoothEnabledDto = {
  bluetoothEnabled: boolean;
  bluetoothManagementState?: BluetoothManagementStateEnum;
};
export type DeviceUnlockOverApiForUserDto = {
  deviceId: string;
  deviceUnlockOverApiService: boolean;
  userUnlockOverApiAllowed: boolean;
};
export type BluetoothUserSiteStatusDto = {
  enabled?: boolean;
  authIdHash?: string;
};
export type UserApartmentDto = {
  id?: string;
  coreId?: string;
  name?: string;
  number?: string;
  siteId?: string;
  devicesCount?: number;
  groups?: GroupDto[];
};
export type GroupPageResponseDto = {
  results?: GroupUsersDevicesDto[];
  resultsTotal?: number;
};
export type OfflinePairingDto = {
  offlinePairing?: boolean;
  acom?: boolean;
  locationIds?: string[];
};
export type PinValueDto = {
  pin?: string;
};
export type SiteApartmentDto = {
  id?: string;
  coreId?: string;
  devicesCount?: number;
  groupsCount?: number;
};
export type AccessUserDto = {
  accessId?: string;
  userId?: string;
};
export type DirectoryUserOperation = 'CREATE' | 'UPDATE' | 'DELETE';
export type UserSynchronizationStatus = 'REQUESTED' | 'SYNCHRONIZED' | 'SYNCHRONIZED_WITH_ERROR';
export type DeviceAccessDto = {
  sn?: string;
  accessId?: string;
  userOperation?: DirectoryUserOperation;
  syncStatus?: UserSynchronizationStatus;
  lastUpdated?: string;
  credentials?: CredentialsDto[];
};
export type DeviceAccessPageResponseDto = {
  results: DeviceAccessDto[];
  resultsFilteredCount: number;
  resultsTotalCount: number;
};
export const {
  useActivatePinForAccessAcMutation,
  useActivatePinForUserAcMutation,
  useAddGroupToApartmentsAcMutation,
  useAssignAccessAcMutation,
  useAssignDeviceAcMutation,
  useAssignGroupToApartment1AcMutation,
  useAssignGroupToApartmentAcMutation,
  useAssignPinToGuestAcMutation,
  useAssignPinToUserWithoutLoginAcMutation,
  useAssignUserAcMutation,
  useCheckBluetoothAccessExistsAcMutation,
  useCreateAccessAcMutation,
  useCreateBluetoothAccessAcMutation,
  useCreateBluetoothAcMutation,
  useCreateDeviceServiceAcMutation,
  useCreateGroupAcMutation,
  useCreateGuestPinWithoutAccessAcQuery,
  useCreateLprForAccessAcMutation,
  useCreatePinForAccessAcMutation,
  useCreatePinForUserAcMutation,
  useCreatePinWithoutAccessAcQuery,
  useCreateRfidForAccessAcMutation,
  useCreateRfidForUserAcMutation,
  useDeleteAccessAcMutation,
  useDeleteAllLprsForAccessAcMutation,
  useDeleteBluetoothAccessAcMutation,
  useDeleteBluetoothAcMutation,
  useDeleteDeviceServiceAcMutation,
  useDeleteGroupAcMutation,
  useDeleteLprForAccessAndLprIdAcMutation,
  useDeletePinForAccessAcMutation,
  useDeletePinForUserAcMutation,
  useDeleteRfidForAccessByIdAcMutation,
  useDeleteRfidForUserByIdAcMutation,
  useDeleteRfidsForAccessAcMutation,
  useDeleteRfidsForUserAcMutation,
  useDisableBluetoothAcMutation,
  useEnableBluetoothAcMutation,
  useGetAccessAcQuery,
  useGetAccessCredentialsValidityAcQuery,
  useGetAccessesInGroupAcQuery,
  useGetAccessInSiteByRfidCodeAcQuery,
  useGetAllAccessesInSiteAcQuery,
  useGetAllLprsForAccessAcQuery,
  useGetApartmentGroupsAcQuery,
  useGetApartmentsOnSiteAcQuery,
  useGetBluetoothAccessAcQuery,
  useGetBluetoothAcQuery,
  useGetBluetoothStatusAcQuery,
  useGetCredentialsAcMutation,
  useGetCredentialsForCompanyAcMutation,
  useGetCredentialsForSiteAcMutation,
  useGetDeviceAccessesAcQuery,
  useGetDeviceServicesAcQuery,
  useGetDeviceServicesInSiteAcQuery,
  useGetDeviceServicesWithoutRoleAcQuery,
  useGetDevicesInGroupAcQuery,
  useGetDevicesInSiteWithBleSupportedAcQuery,
  useGetDeviceUnlockOverApiAcQuery,
  useGetGroupAcQuery,
  useGetGroupsInSiteByAccessAcQuery,
  useGetGroupsInSiteByDeviceAcQuery,
  useGetGroupsInSiteByUserAcQuery,
  useGetGroupsOfUsersInSiteAcMutation,
  useGetLprByAccessAndLprIdAcQuery,
  useGetOfflinePairingAcQuery,
  useGetPinByIdForAccessAcQuery,
  useGetPinByIdForUserAcQuery,
  useGetPinForAccessAcQuery,
  useGetPinForUserAcQuery,
  useGetRfidForAccessByIdAcQuery,
  useGetRfidForUserByIdAcQuery,
  useGetRfidsForAccessAcQuery,
  useGetRfidsForUserAcQuery,
  useGetServicesAcMutation,
  useGetServicesInSiteAcQuery,
  useGetServicesInSiteByDeviceIdsAcMutation,
  useGetServicesWithoutRoleAcMutation,
  useGetSiteCredentialsSettingsAcQuery,
  useGetSiteGuestPinSettingsAcQuery,
  useGetUnlockOverApiDevicesForUserAcQuery,
  useGetUserApartmentsAcQuery,
  useGetUserCredentialsValidityAcQuery,
  useGetUsersInGroupAcQuery,
  useListAllApartmentsAcQuery,
  useListAllGroups1AcQuery,
  useListAllGroupsAcQuery,
  useListAllGroupsPagedAcQuery,
  usePutAccessesIntoGroupAcMutation,
  usePutAccessIntoGroupsAcMutation,
  usePutDeviceIntoGroupsAcMutation,
  usePutDevicesIntoGroupAcMutation,
  usePutUserIntoGroupsAcMutation,
  usePutUsersIntoGroupAcMutation,
  useRecreateBluetoothAccessAcMutation,
  useRecreateBluetoothAcMutation,
  useRemoveAccessAcMutation,
  useRemoveDeviceAcMutation,
  useRemoveGroupFromApartment1AcMutation,
  useRemoveGroupFromApartmentAcMutation,
  useRemoveUserAcMutation,
  useSetAccessLogActiveAcMutation,
  useSetAcmActiveAcMutation,
  useSetDeviceUnlockOverApiServiceAcMutation,
  useSetGroupsToApartmentAcMutation,
  useTriggerUnlockOverApiAcMutation,
  useUpdateAccessCredentialsValidityAcMutation,
  useUpdateGroupAcMutation,
  useUpdateSiteBluetoothAcMutation,
  useUpdateSiteCustomLocationAcMutation,
  useUpdateSiteGuestPinSettingsAcMutation,
  useUpdateUserCredentialsValidityAcMutation,
} = injectedRtkApi;
